import AbstractScene from './AbstractScene.js';
import Deck from '../prefabs/Deck.js';
import Deck2 from '../prefabs/Deck2.js';
import { Colors } from '../consts/Colors.js';
import RoundedButton2 from '../prefabs/RoundedButton2.js';
import ItemZone from '../prefabs/ItemZone.js';
import ItemZoneDone from '../prefabs/ItemZoneDone.js';
import { ItemsData } from '../consts/ItemsData.js';
import { CartesInfos } from '../consts/CartesInfos.js';
import { ZonesData } from '../consts/ZonesData.js';
import Zone from '../prefabs/Zone.js';
import EndBoard from '../prefabs/EndBoard.js';

export default class Schema extends AbstractScene {
    constructor() {
        super({
            key: "Schema"
        })
    }
    init(data) {
        this._init(data);
        this.cardNumber = this.game.data.cardNumber;
        this.itemsAll = []
        this.allZonesDone = []
        this.isDragging = false;
    }

    preload() {
        this._preload();
        this.score = {
            bravo: 0,
            presque: 0,
            mauvais: 0
        }
    }

    create() {
        this.cardsDataRandom = CartesInfos.sort(() => Math.random() - 0.5);
        this.background = this.add.image(0, 0, 'background').setOrigin(0, 0)
        this.stepText = this.add.text(1400, 900, "Étape 1", {
            font: "22px MassiliaBold",
            color: Colors.Text.Red,
            align: "left",
            wordWrap: { width: 333, useAdvancedWrap: true }
        }).setOrigin(0)
        this.stepText.setAlpha(0)
        this.consigne = this.add.text(1400, 960, "Placez chaque photographie dans la bonne case des Soldes Intermédiaires de Gestion (SIG).", {
            font: "22px MassiliaMediumOblique",
            color: Colors.Text.White,
            align: "left",
            wordWrap: { width: 493, useAdvancedWrap: true }
        }).setOrigin(0, 0.5)
        this.consigne.setAlpha(0)
        this.deck = new Deck(this, 1085, 855);
        this.deck.setDepth(1)
        this.addItemZones()
        this.introGame();
    }

    addItemZones() {
        for (let i = 0; i < ItemsData.length; i++) {
            let item = ItemsData[i];
            this['itemZone' + item.index] = new ItemZone(this, item.itemX, item.itemY, item);
            this.itemsAll.push(this['itemZone' + item.index])
        }
    }

    startGame() {
        this.deck.setDeckAction(CartesInfos[this.cardNumber])
        this.consigne.setAlpha(1)
        this.stepText.setAlpha(1)
        this.itemsAll.forEach(x => x.setActive())
    }

    launchStep2() {
        this.allZonesDone.forEach(x => {
            x.disableInteractive()
        })
        this.allFatZones = []
        ZonesData.forEach(zone => {
            this["zoneImg" + zone.zoneId] = this.add.image(zone.zoneX, 388, zone.image).setOrigin(0.5);
            this["zoneImg" + zone.zoneId].zoneId = zone.zoneId
            this.allFatZones.push(this["zoneImg" + zone.zoneId])
        })
        this.allZones = []
        ZonesData.forEach(zone => {
            this['zone' + zone.zoneId] = new Zone(this, zone)
            this.allZones.push(this['zone' + zone.zoneId])
        })
        this.plus1 = this.add.image(718, 147, 'plus').setOrigin(0.5);
        this.plus2 = this.add.image(1259, 147, 'plus').setOrigin(0.5);
        this.deck.destroy()
        this.stepText.setText("Étape 2")
        this.stepText.y = 890
        this.stepText.x = 1393
        this.consigne.setText("Placez les noms des trois cycles financiers utilisés pour décrire et analyser le fonctionnement d'une entreprise sur le schéma.")
        this.deck2 = new Deck2(this, 1085, 855);
        this.introGame2();
    }

    launchEndBoard() {
        new EndBoard(this, this.score)
    }

    introGame() {
        this.introBack = this.add.rectangle(0, 0, 1920, 1080, Colors.Elmt.DarkBlue, 0.5).setOrigin(0, 0);
        this.intoPopUp = this.add.rexRoundRectangle(960, 575, 934, 380, 47, Colors.Elmt.White).setOrigin(0.5).setDepth(1)

        let cons = {
            text: 'Vous allez devoir reconstituer en deux étapes le schéma final de la vidéo sur les Soldes Intermédiaires de Gestion.\n\nDans cette première étape, placez chaque photographie dans la bonne case des',
            config: { size: '30px', fontFamily: 'MassiliaMediumOblique', align: 'center', color: Colors.Text.DarkBlue, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 790 }
        }
        this.introConsigne = this.createTextElement(960, 510, cons).setDepth(1)
        let titre = {
            text: 'Soldes Intermédiaires de Gestion (SIG)',
            config: { size: '40px', fontFamily: 'MassiliaMedium', align: 'center', color: Colors.Text.DarkBlue, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 790 }
        }
        this.introTitre = this.createTextElement(960, 640, titre).setDepth(1)
        this.introBtn = new RoundedButton2(this, 960, 700, 212, "Commencer", Colors.Text.White, Colors.Elmt.DarkBlue).setDepth(1);
        // this.startBtn = new RoundedButton2(this, 960, 660, 212, "Commencer", Colors.Text.White, Colors.Elmt.DarkBlue).setAlpha(0).setDepth(1);
        this.introBtn.setClickFunction(() => {
            this.introBtn.destroy();
            this.introBack.destroy();
            this.intoPopUp.destroy();
            this.introConsigne.destroy();
            this.introTitre.destroy();
            this.startGame()
        })

    }
    introGame2() {
        this.introBack = this.add.rectangle(0, 0, 1920, 1080, Colors.Elmt.DarkBlue, 0.5).setOrigin(0, 0);
        this.intoPopUp = this.add.rexRoundRectangle(960, 539, 934, 250, 47, Colors.Elmt.White).setOrigin(0.5);
        let cons = {
            text: 'Bravo !\nVous avez placé toutes les photographies dans la bonne case !',
            config: { size: '32px', fontFamily: 'MassiliaMediumOblique', align: 'center', color: Colors.Text.DarkBlue, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 790 }
        }
        this.introConsigne = this.createTextElement(960, 500, cons)
      
        this.introBtn = new RoundedButton2(this, 960, 620, 212, "Continuer", Colors.Text.White, Colors.Elmt.DarkBlue);
        this.introBtn.setClickFunction(() => {
            
            this.intoPopUp.destroy();
            this.introConsigne.destroy();
            this.introBtn.destroy();

            this.intoPopUp2 = this.add.rexRoundRectangle(960, 539, 934, 350, 47, Colors.Elmt.White).setOrigin(0.5);
                     let titre2 = {
                text: "Dans cette deuxième étape, placez les noms des trois cycles financiers utilisés pour décrire et analyser le fonctionnement d'une entreprise sur le schéma des",
                config: { size: '32px', fontFamily: 'MassiliaMediumOblique', align: 'center', color: Colors.Text.DarkBlue, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 790 }
            }
            this.introTitre2 = this.createTextElement(960, 500, titre2)
            let cons2 = {
                text: ' Soldes Intermédiaires de Gestion (SIG).',
                config: { size: '32px', fontFamily: 'MassiliaBold', align: 'center', color: Colors.Text.DarkBlue, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 790 }
            }
            this.introConsigne2 = this.createTextElement(960, 580, cons2)
   
            this.introBtn2 = new RoundedButton2(this, 960, 670, 212, "Commencer", Colors.Text.White, Colors.Elmt.DarkBlue);
            this.introBtn2.setClickFunction(() => {
                this.introBack.destroy();
                this.intoPopUp2.destroy();
                this.introConsigne2.destroy();
                this.introTitre2.destroy();
                this.introBtn2.destroy();
                this.allZones.forEach(x => x.setActive())
            })

        })

    }

    replaceItem(x, y, itemData) {
        this.zoneDone = new ItemZoneDone(this, x, y, itemData, this.deck)
        this.allZonesDone.push(this.zoneDone)

    }
}